var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main" },
            [
              _c("SubTitleComponent", { attrs: { title: _vm.title } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        model: _vm.form,
                        "label-width": "120px",
                        "label-position": "top"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户名称" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入客户公司名称" },
                            model: {
                              value: _vm.form.name,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "地区" } },
                        [
                          _c("el-cascader", {
                            attrs: {
                              options: _vm.cityData,
                              props: { expandTrigger: "hover" },
                              placeholder: "请选择省/市/区"
                            },
                            on: { change: _vm.handleChange },
                            model: {
                              value: _vm.form.selectedOptions,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "selectedOptions", $$v)
                              },
                              expression: "form.selectedOptions"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "行业类型" } },
                        [
                          _vm.industryData.length > 0
                            ? _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择行业类型" },
                                  model: {
                                    value: _vm.form.industry,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "industry", $$v)
                                    },
                                    expression: "form.industry"
                                  }
                                },
                                _vm._l(_vm.industryData, function(item, index) {
                                  return _c("el-option", {
                                    key: "industry" + index,
                                    attrs: {
                                      label: item.industry_type,
                                      value: item.industry_type
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "项目类型" } },
                        [
                          _vm.projectData.length > 0
                            ? _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "type", $$v)
                                    },
                                    expression: "form.type"
                                  }
                                },
                                _vm._l(_vm.projectData, function(item, index) {
                                  return _c("el-radio", {
                                    key: "project" + index,
                                    attrs: {
                                      label: item.project_type,
                                      value: item.project_type
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "项目面积（m²）" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入项目面积" },
                            model: {
                              value: _vm.form.square,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "square", $$v)
                              },
                              expression: "form.square"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "项目联系人" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入项目联系人" },
                            model: {
                              value: _vm.form.contact_neme,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "contact_neme", $$v)
                              },
                              expression: "form.contact_neme"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系方式" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入联系方式" },
                            model: {
                              value: _vm.form.contact_phone,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "contact_phone", $$v)
                              },
                              expression: "form.contact_phone"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: { click: _vm.onSubmit }
                            },
                            [_vm._v("保存")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2273cee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2273cee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Customer/New.vue
// module id = null
// module chunks = 